import React from "react";

interface CardProps {
  logo: string; // URL del logo
  title: string;
  description: string;
  link?: string;
  same?: boolean;
  onClick?: any;
}

const Card: React.FC<CardProps> = ({
  logo,
  title,
  description,
  link,
  same = false,
  onClick,
}) => {
  return link ? (
    <a
      href={link}
      target={same ? "_self" : "_blank"}
      rel="noopener noreferrer"
      className="flex items-center bg-white rounded-xl shadow-md p-3 sm:p-4 w-full hover:shadow-lg transition-shadow group min-h-18"
    >
      <div className="shrink-0 mr-3 sm:mr-4">
        <img
          src={logo}
          alt="logo"
          className="w-12 h-12 sm:w-16 sm:h-16 object-contain transition-transform duration-300 group-hover:scale-110 group-hover:rotate-6"
        />
      </div>
      <div className="flex-1 flex flex-col justify-between">
        <div>
          <h2 className="text-base sm:text-lg font-semibold text-gray-900 mb-1">
            {title}
          </h2>
          <p className="text-xs sm:text-sm text-gray-500 mb-2">{description}</p>
        </div>
      </div>
    </a>
  ) : (
    <button
      onClick={onClick}
      className="flex cursor-pointer items-center bg-white rounded-xl shadow-md p-3 sm:p-4 w-full hover:shadow-lg transition-shadow group min-h-18"
    >
      <div className="shrink-0 mr-3 sm:mr-4">
        <img
          src={logo}
          alt="logo"
          className="w-12 h-12 sm:w-16 sm:h-16 object-contain transition-transform duration-300 group-hover:scale-110 group-hover:rotate-6"
        />
      </div>
      <div className="flex-1 flex flex-col justify-between">
        <div>
          <h2 className="text-base sm:text-lg font-semibold text-gray-900 mb-1">
            {title}
          </h2>
          <p className="text-xs sm:text-sm text-gray-500 mb-2">{description}</p>
        </div>
      </div>
    </button>
  );
};

export default Card;
